import { useEffect, useState } from "react";
import { Box, Skeleton, Tab, Tabs, Typography } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid';
import { useParams, useSearchParams } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { UBHourlyFilter } from "./UBHourlyFilter";
import moment from "moment";
import { TabPanel } from "../../components/TabPanel";
import { UBItem } from "./UBItem";
import { shortenFloat, shortenNumber } from "../../utils/number";

const columns = [
    { field: 'category_label', headerName: 'Hour', width: 300, align: "left"},
    { field: 'count_00', headerName: '12am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_01', headerName: '1am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_02', headerName: '2am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_03', headerName: '3am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_04', headerName: '4am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_05', headerName: '5am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_06', headerName: '6am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_07', headerName: '7am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_08', headerName: '8am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_09', headerName: '9am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_10', headerName: '10am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_11', headerName: '11am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_12', headerName: '12pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_13', headerName: '1pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_14', headerName: '2pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_15', headerName: '3pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_16', headerName: '4pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_17', headerName: '5pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_18', headerName: '6pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_19', headerName: '7pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_20', headerName: '8pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_21', headerName: '9pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_22', headerName: '10pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_23', headerName: '11pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)}
];

const eventColumns = [
    { field: 'event_label', headerName: 'Hour', width: 300, align: "left"},
    { field: 'count_00', headerName: '12am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_01', headerName: '1am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_02', headerName: '2am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_03', headerName: '3am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_04', headerName: '4am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_05', headerName: '5am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_06', headerName: '6am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_07', headerName: '7am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_08', headerName: '8am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_09', headerName: '9am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_10', headerName: '10am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_11', headerName: '11am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_12', headerName: '12pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_13', headerName: '1pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_14', headerName: '2pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_15', headerName: '3pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_16', headerName: '4pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_17', headerName: '5pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_18', headerName: '6pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_19', headerName: '7pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_20', headerName: '8pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_21', headerName: '9pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_22', headerName: '10pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_23', headerName: '11pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)}
];

const UBDetailSkeleton = () => {
    return (
        <><Skeleton /><Skeleton /><Skeleton /></>
    );
};

export const UBDetail = () => {
    const { dashboard: pDashboard } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const [date, setDate] = useState(moment(searchParams.get("date") ?? new Date()));
    const [dateFormatted, setDateFormatted] = useState({
        date: date.format("YYYY-MM-DD"),
    });

    const { status: enrollmentStatus, data: enrollmentData } = useFetchData({
        endpoint: `unionbank/${pDashboard}/24hours/enrollment`,
        params: dateFormatted,
        defaultData: []
    });

    useEffect(() => {
        setDateFormatted({
            date: date.format("YYYY-MM-DD"),
        })
    }, [date]);

    useEffect(() => {
        searchParams.set("date", date);
        setSearchParams(searchParams);
    }, [date, searchParams, setSearchParams]);

    return (
        <Box
            container
            minHeight="95vh"
            height="100%"
            sx={{
                p: 1
            }}
        >
            <Box>
                <UBHourlyFilter value={date} onChange={setDate} />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    Enrollment Number by Current Hour
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "account_creation")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "call_to_action" && event?.event_name === "account_creation")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "general_enrollment" && event?.event_name === "account_creation")}
                    ]}
                    columns={columns}
                    hideFooter
                    autoHeight
                />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    Cumulative for Current Hour
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "fte_account_creation")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "cta_account_creation")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "general_account_creation")}
                    ]}
                    columns={eventColumns}
                    hideFooter
                    autoHeight
                />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    Fast Track Enrollment
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "sso")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "already_enrolled")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "net_new_handshake")},
                        { id: 4, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "otp_success")},
                        { id: 5, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "otp_success_rate")},
                        { id: 6, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "account_creation")},
                        { id: 7, ...enrollmentData?.find(event => event?.category_name === "fast_track" && event?.event_name === "success_rate")}
                    ]}
                    columns={eventColumns}
                    hideFooter
                    autoHeight
                />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    Call to Action Enrollment
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "call_to_action" && event?.event_name === "identify_customer")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "call_to_action" && event?.event_name === "otp_success")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "call_to_action" && event?.event_name === "otp_success_rate")},
                        { id: 4, ...enrollmentData?.find(event => event?.category_name === "call_to_action" && event?.event_name === "account_creation")},
                        { id: 5, ...enrollmentData?.find(event => event?.category_name === "call_to_action" && event?.event_name === "success_rate")}
                    ]}
                    columns={eventColumns}
                    hideFooter
                    autoHeight
                />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    FTE + CTA Total
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "fte_cta_total" && event?.event_name === "customer_start")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "fte_cta_total" && event?.event_name === "account_creation")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "fte_cta_total" && event?.event_name === "success_rate")},
                    ]}
                    columns={eventColumns}
                    hideFooter
                    autoHeight
                />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    General Enrollment
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "general_enrollment" && event?.event_name === "identify_customer")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "general_enrollment" && event?.event_name === "otp_success")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "general_enrollment" && event?.event_name === "otp_success_rate")},
                        { id: 4, ...enrollmentData?.find(event => event?.category_name === "general_enrollment" && event?.event_name === "account_creation")},
                        { id: 5, ...enrollmentData?.find(event => event?.category_name === "general_enrollment" && event?.event_name === "success_rate")}
                    ]}
                    columns={eventColumns}
                    hideFooter
                    autoHeight
                />
            </Box>

            <Box sx={{ py: 1, width: "100%" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom align="left"
                >
                    FTE + CTA + General Total
                </Typography>

                <DataGrid
                    title=""
                    rows={[
                        { id: 1, ...enrollmentData?.find(event => event?.category_name === "total" && event?.event_name === "customer_start")},
                        { id: 2, ...enrollmentData?.find(event => event?.category_name === "total" && event?.event_name === "account_creation")},
                        { id: 3, ...enrollmentData?.find(event => event?.category_name === "total" && event?.event_name === "success_rate")},
                    ]}
                    columns={eventColumns}
                    hideFooter
                    autoHeight
                />
            </Box>
        </Box>
    );
}